import Head from 'next/head'


import { GetServerSideProps } from 'next';

import Layout from '../components/Layout';
import { MenuId } from '../components/Header';
import { getUserInformation, getWpPost, getYoastData, isPrivateRedirect, isVideoUrl, redirectUrl } from '../lib/data';
import { WPPost, YoastData } from '../lib/definitions';
import { translateWPBlocksToJSX } from '../lib/parser';

import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { localCache } from '../lib/localcache';
import EmailSignupBanner from '../components/EmailSignupBanner';
import { Space } from '@mantine/core';
import {formattedDateFromString } from '../components/Localization';
import styles from './[uri].module.scss'
import { consoleLog } from '../lib/logger';

const _urlsToRedirect = new Map<string,string> (
[
  ['raw-umber-subscription',  'subscription'],
  ['purchase-gift-voucher',  'subscription?gift=1'],
  ['raw-umber-studios', 'about-our-studio']
]);

const _urlsToBlock : string [] =
  [
    'thank-you-for-your-order',
    'registration-checkout',
    'transactions',
    'shop',
    'member-login',
    'raw-umber-subscription-october-offer',
    'the-tutors',
    'the-venues',
    'thank-you-for-your-order',
    'registration-checkout',
    'transactions',
    'thank-you',
    'registration-cancelled',
    'materials-list',
    'thank-you-for-subscribing-old',
    'felicia-forte-the-alla-prima-portrait',
    'lucas-garcia-drawing-the-portrait-in-charcoal-and-chalk',
    'past-events',
    'online-resources',
    'model-packs',
    'youtube-channel-an-invitation',
    'shop',
    'member-login',
    'drawing-fundamentals-with-lizet-dingemans',
    'changes-to-our-online-portrait-and-figure-drawing-sessions',
    'feedback-wanted',
    'wanted-portrait-models',
    'hints-for-videoing',
    'survey-thank-you',
    'raw-umber-challenge',
    'edit-stripe-payment',
    'edit-stripe-success',
    'cancel-subscription',
    'checkout1',
    'checkout-new-user',
    'checkout-cart',
    'subscription-success',
    'oil-painting-course-with-lizet-dingemans',
    'subscribe-to-email',
    'booking-success',
    'pegasus-art-vouchers',
    'pegasus-art-promotion',
    'covid-measures',
    'subscriber-competition',
    'subscriber-competition-bonus-video',
    'subscriber-competition-terms-conditions',
    'untutored-life-drawing-at-raw-umber-studios',
    'checkout-already-subscribed',
    'raw-umber-subscription-renewal-offer',
    'upload-chat-image',
    'upload-chat-image-success',
    'raw-umber-subscription-october-offer',
    'gift-success',
    'redeem-gift-voucher-2',
    'redeem-gift-voucher-new-user',
    'redeem-gift-voucher-success',
    'thank-you-for-subscribing',
    'online-drawing-sessions-b',
    'online-drawing-sessions-c',
    'unsubscribe',
    'download-chat',
    'artists-wanted',
    'register-interest-teresa-oaxaca-2023',
    'course-thumbnails',
    'half-price-places-on-lizet-dingemanss-still-life-workshops-for-under-30s'

    
  ];


const aRegEx = new RegExp(/<a([^>])*?(href="([^"]*)")+?[^>]*>([^<]*)<\/a>/g);
const redirectRegEx = new RegExp(/(https:\/\/rawumberstudios.com|\/)(\/n\/)?(.*)/);

export default function SlugPage( props : {post:WPPost, yoast: YoastData, mustLoadPlayer : boolean}) {


  
  const router = useRouter();

  let jsx = translateWPBlocksToJSX(props.post.contents, null);
  
  let title = (props.yoast.title?props.yoast.title:props.post.title);
  let description = (props.yoast.description?props.yoast.description:props.post.excerpt);


  function handleLinkClick(event: MouseEvent) {
    const link = event.currentTarget as HTMLAnchorElement
    const href = link.getAttribute('href')
    const target = link.getAttribute('target')
    const url = new URL(href || '', window.location.origin)

    const isInternalLink = url.origin === window.location.origin
    const isOpenedInSameWindow = !target || target === '_self'
    const isLeftButtonClick = event.button === 0
    
    // E.g. Ctrl-clicking a link opens it in a new tab
    // so let the browser handle such clicks
    const isModifierKeyPressed =
      event.altKey || event.ctrlKey || event.metaKey || event.shiftKey

      let u = href??'';

    if (
      (isInternalLink || redirectRegEx.exec(u)) &&
      isOpenedInSameWindow &&
      isLeftButtonClick &&
      !isModifierKeyPressed
    ) {
      


          u = u.replace(redirectRegEx, "$3");
          if (u.length==0)
          {
              u='/';
          }
          else if (u=='/n/' || u=='/n' || u=='n' || u=='n/')
          {
            u='/';
          }
          else if (u.startsWith('n/'))
          {
              u = u.substring(2);
          }
          else if (!u.startsWith("http") && !u.startsWith("/"))
          {
              u = '/' + u;
          }
          
          if (u.startsWith("http"))
          {
              //consoleLog("Redirecting to " + u);
              //window.location.href=u;
          }
          else
          {
            event.preventDefault();
            router.push(u);
          }
          return false;
  }
}
  useEffect(()=>
    {
      
      const links = document.querySelectorAll('a');
      links.forEach((link) => link.addEventListener('click', handleLinkClick));
      
      return (() => {
        links.forEach((link) =>
          link.removeEventListener('click', handleLinkClick));
        }
        );
    },
    [router]);

  return (
    <Layout menuId={props.post.type=='post'?MenuId.home:MenuId.home}>

      <Head>
        <title>{title}</title>
        <meta name='description' content={description}/>
        {props.yoast.noIndex && <meta name='robots' content='noindex'/>}
        <link rel="icon" href="favicon.ico"></link>
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png"></link>
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"></link>
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"></link>
      <link rel="manifest" href="/site.webmanifest"></link>


  
      </Head>

      <main>
        <div className="inside-article">
        <div className="entry-content">
          <div className="siteHeader">
            <h1 className="title">
                {props.post.title}
            </h1>
            {props.post.type=="post" && <h2 className={styles.h2}>{formattedDateFromString(props.post.date)}  </h2>}
          </div>
            {jsx}
            </div>
            </div>

      <Space h='md'/>
            <EmailSignupBanner/>
  </main>



    </Layout>
  )
}

export const getServerSideProps : GetServerSideProps = async (context)=>
{

  let url = context?.params?.uri as string;
  const {override} = context.query;
  let user = await getUserInformation(context.req);

  let showPost =  !!(user && override && user.is_admin);

  
  if (!url)
  {
    return { notFound: true };
  }

  if (url.endsWith('/'))
  {
    url = url.substring(0, url.length - 1);
  }

  var u = _urlsToRedirect.get(url);

  if (u)
  {
    return {
      redirect: 
      {
        destination: "/" + u,
        permanent: false
      }
    }

  }

  let urlMap = await localCache.getObject<Map<string, boolean>>("legacyblocks", async ()=>
  {
    let m : Map<string, boolean> = new Map<string,boolean>();
    _urlsToBlock.forEach(x=> { m.set(x, true)});
    return m;
  });



  if (urlMap.get(url))
  {
    return { notFound: true };
  }
  
  var u2 = await redirectUrl(context.resolvedUrl);

  if (u2)
  {
    return {
      redirect: 
      {
        destination: (u2.startsWith('/')?'':'/') + u2,
        permanent: false
      }
    }
  }

  const post = await getWpPost(url, showPost);

  if (!post)
  {

    //see if it's a video or a live link - this is only true for older videos

    if (await isPrivateRedirect(url))
    {
      return {
        redirect:
        {
        destination: "/live/" + url,
        permanent: true
        }
      }
    }

    let s = await isVideoUrl(url);

    if (s)
    {
      return {
        redirect:
        {
        destination: "/videos/" + s,
        permanent: true
        }
      }
    }
    return {
      notFound: true
    } 
  }


  
  let yoast = await getYoastData(post.id);

  return {
    props: {
      post: post,
      mustLoadPlayer: true,
      yoast: yoast},
  }
}



